import React from 'react';
import UserModifyTableView from '../../views/user/modify-table';
import { UserCollection } from '../../services/collection';
import { withRouter } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';
import UpdateUserPasswordModal from '../../views/user/update-password-modal';
import { changeUserPassword } from '../../services/core-data';

class UserModifyTableScreen extends React.Component {

  state = {
    filter: '',
    editing: null,
    selected: null,
    changePassword: null,
    changePasswordDisabled: false
  };

  onAdd = () => {
    const { history } = this.props;
    history.push('/user/create');
  };

  onChange = editing => this.setState({
    editing
  });

  onSelect = (unused, selected) => this.setState({
    editing: null,
    selected
  });

  onUnselect = () => this.setState({
    editing: null,
    selected: null
  });

  onFilter = filter => this.setState({
    filter
  });

  onSave = async () => {
    if (!this.isValid()) {
      return null;
    }
    const { editing: user } = this.state;
    await new Promise(resolve => this.setState({
      disabled: true
    }, resolve));
    try {
      await UserCollection.actions.update(user);
      await new Promise(resolve => this.setState({
        disabled: false,
        selected: null,
        editing: null
      }, resolve));
    } catch(e) {
      console.warn(e);
      alert('Failed to save user');
      await new Promise(resolve => this.setState({
        disabled: false
      }, resolve));
    }
  };

  onCancel = () => this.onUnselect();

  isValid() {
    const { editing } = this.state;
    if (!editing) {
      return false;
    }
    const { userName, firstName, lastName, active } = editing;
    return !!(
      userName &&
      isEmail(userName) &&
      firstName &&
      lastName &&
      typeof active === 'boolean'
    );
  }

  onPasswordChange = (property) => {
    return (value) => this.setState(({ changePassword }) => ({
      changePassword: changePassword ? {
        ...changePassword,
        [property]: value
      } : null
    }))
  };

  onTriggerChangeUserPassword = () => this.setState(({ selected }) => ({
    changePassword: (selected && selected.uuid) ? {
      uuid: selected.uuid
    } : null
  }));

  isChangePasswordValid() {
    const { changePassword } = this.state;
    if (!changePassword) {
      return false;
    }
    const {
      uuid,
      password,
      passwordRepeated,
      currentPassword
    } = changePassword;
    return !!(
      uuid &&
      currentPassword &&
      password &&
      passwordRepeated &&
      password.length >= 8 &&
      passwordRepeated.length >= 8 &&
      password === passwordRepeated
    );
  }

  onSavePassword = async () => {
    if (!this.isChangePasswordValid()) {
      return null;
    }
    const { changePassword } = this.state;
    await new Promise(resolve => this.setState({
      disabled: true,
      changePasswordDisabled: true
    }, resolve));
    try {
      await changeUserPassword({
        uuid: changePassword.uuid,
        currentPassword: changePassword.currentPassword,
        newPassword: changePassword.password
      });
      await new Promise(resolve => this.setState({
        disabled: false,
        changePasswordDisabled: false,
        changePassword: null
      }, resolve));
    } catch(e) {
      console.warn(e);
      alert('Failed to change user password');
      await new Promise(resolve => this.setState({
        disabled: false,
        changePasswordDisabled: false
      }, resolve));
    }
  };

  onCancelPassword = () => this.setState({
    changePassword: null
  });

  render() {
    const { onAdd, onChange, onSelect, onUnselect, onFilter, onSave, onCancel, onTriggerChangeUserPassword, onSavePassword, onCancelPassword, onPasswordChange } = this;
    const { selected, editing, filter, disabled, changePassword, changePasswordDisabled } = this.state;
    const { list = [], loading } = this.props;
    return (
      <React.Fragment>
        <UserModifyTableView
          onAdd={onAdd}
          onChange={onChange}
          onSelect={onSelect}
          onUnselect={onUnselect}
          onFilter={onFilter}
          onSave={onSave}
          onCancel={onCancel}
          filter={filter}
          items={list}
          user={editing || selected}
          disabled={disabled || !!loading}
          canSave={this.isValid()}
          onChangePassword={onTriggerChangeUserPassword}
        />
        <UpdateUserPasswordModal
          isOpen={!!changePassword}
          currentPassword={(changePassword ? changePassword.currentPassword : '') || ''}
          password={(changePassword ? changePassword.password : '') || ''}
          passwordRepeated={(changePassword ? changePassword.passwordRepeated : '') || ''}
          onCurrentPassword={onPasswordChange('currentPassword')}
          onPassword={onPasswordChange('password')}
          onPasswordRepeated={onPasswordChange('passwordRepeated')}
          canSave={this.isChangePasswordValid()}
          onSave={onSavePassword}
          onCancel={onCancelPassword}
          onToggle={onCancelPassword}
          disabled={changePasswordDisabled}
        />
      </React.Fragment>
    )
  }
}

export default UserCollection.connect(state => state)(withRouter(UserModifyTableScreen));


// WEBPACK FOOTER //
// ./src/app/user/index.js